import { createSlice } from '@reduxjs/toolkit';

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState: {
    showPoints: false,
    userPersona: '',
    myConcentList: [],
  },
  reducers: {
    setShowPoints: (state, action) => {
        state.showPoints = action.payload.showPoints
    },
    setDocumentExist: (state, action) => {
        state.documentExist = action.payload.documentExist
    },
    setLang: (state, action) => {
      state.lang = action.payload.lang
    },
    setUserPersona: (state, action) => {
      state.userPersona = action.payload.userPersona
    },
    setContractorCount: (state, action) => {
      state.contractorCount = action.payload.contractorCount;
    },
    setMyConcentList: (state, action) => {
      state.myConcentList = action.payload.myConcentList;
    },
    setProductWiseSaleData: (state, action) => {
      state.productWiseSaleData = action.payload.productWiseSaleData;
    },
    setServiceWiseSaleData: (state, action) => {
      state.serviceWiseSaleData = action.payload.serviceWiseSaleData;
    },
    setBasicProfileDetails: (state, action) => {
      state.basicProfileDetails = action.payload.basicProfileDetails;
      state.canUpdateBasicProfile = action.payload.canUpdate;
    },
    setPurchaseProductList: (state, action) => {
      state.purchaseProductList = action.payload.purchaseProductList;
      state.purchaseProductBrandId = action.payload.purchaseProductBrandId;
    }
  },
});

export const addShowPoints  = currentUserSlice.actions.setShowPoints;
export const addDocumentExist = currentUserSlice.actions.setDocumentExist;
export const addLanguage = currentUserSlice.actions.setLanguage;
export const addUserPersona = currentUserSlice.actions.setUserPersona;
export const addContractorCount = currentUserSlice.actions.setContractorCount;
export const addMyConcentList = currentUserSlice.actions.setMyConcentList;
export const addProductWiseSaleData = currentUserSlice.actions.setProductWiseSaleData;
export const addServiceWiseSaleData = currentUserSlice.actions.setServiceWiseSaleData;
export const addBasicProfileDetails = currentUserSlice.actions.setBasicProfileDetails;
export const addPurchaseProductList = currentUserSlice.actions.setPurchaseProductList;

export default currentUserSlice.reducer;